import React from "react";
import { useLiveData } from "../../live/LiveDataProvider";
import EventsScroller from "../flash-odds/EventsScroller";

export default function TopLive() {
    const liveData = useLiveData();

    
    if (liveData == null || liveData.matches.length === 0) {
        return null;
    }

    const events = liveData.matches.slice(0, 10);

    return <EventsScroller data={events} icon={'boost_offer.svg'} title={'TopLive'} />;
}
